export const FieldDecorator: React.FC<React.PropsWithChildren<{}>> = ({
  children,
}) => (
  <div className="FieldDecorator border-l-0 border-l-primary">{children}</div>
);
